<dspx-card-set-base-form
                         [formServiceEndpoint]="formServiceEndpoint"
                         [fieldTypeReplacements]="fieldTypeReplacements"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [entityId]="id"
                         formName="Payment Rule"
                         (onButtonClick)="buttonClick($event)"
                         (onActionButtonClick)="actionButtonClick($event)"
                         (onDialogSubmit)="dialogSubmit($event)"
                         (onFilter)="filter($event)"
                         (onFormLoad)="formLoaded($event)"
                         (onModelChange)="modelChange($event)"
                         (onSave)="save($event)"
                         (onCancel)="cancel($event)">
</dspx-card-set-base-form>
